const PaymentSuccess = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <h1 className="text-3xl font-bold text-green-600">
        🎉 Thanh toán thành công!
      </h1>
      <p>Cảm ơn bạn đã mua hàng. Đơn hàng của bạn đã được ghi nhận.</p>
    </div>
  );
};

export default PaymentSuccess;
